<!-- eslint-disable no-await-in-loop -->
<template>
    <div class="ah-page service-fee-statement-transform-page">
        <div class="page-header" id="payment-page-header" style="margin-bottom: 25px">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>轉送請款單</h1>
                    </div>
                    <div class="actions">
                        <el-button v-if="form.sno" size="small" @click="onDelete" type="danger" style="margin-top: 5px">作廢請款單</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <div class="transfer-graph">
                        <div class="from">
                            <span>勞報單</span>
                        </div>
                        <div class="arrow"><div class="arrow-line"></div></div>
                        <div class="to">
                            <span>請款單</span>
                            <span v-if="isRejectedMode" class="reject-label">退件</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" :label-position="isMobile() ? 'top' : 'right'" label-width="200px">
            <div class="ah-container">
                <!-- 選取勞報單面板 -->
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">勞報單列表</div>
                        <div class="panel-action">
                            <el-button size="mini" @click="onAddServiceFeeStatement" icon="el-icon-plus" round>加選</el-button>
                        </div>
                    </div>
                    <div class="panel-body">
                        <selected-service-fee-table :loading="isLoading" :data="selectedServiceFeeList" @remove-item="removeSelectedServiceFeeBySno" />
                    </div>
                </div>
                <template v-if="selectedServiceFeeList.length">
                    <el-alert type="warning" show-icon :closable="false">
                        <div style="font-size: 10pt; padding-bottom: 5px">
                            <div v-if="isRejectedMode">提醒您，如需修改勞報單欄位，請先作廢本請款單、編輯來源勞報單後再次轉送請款。</div>
                            <div v-else>提醒您，如需修改勞報單資訊欄位，請回勞報單編輯後再轉送。</div>
                        </div>
                    </el-alert>
                    <!-- 請款資訊面板 -->
                    <div class="ah-panel">
                        <div class="panel-header small">
                            <div class="panel-title">請款資訊</div>
                        </div>
                        <div class="panel-body">
                            <el-form-item label="請款單類型">
                                <payment-type-select v-model="form.typ" :isProjectOnly="isProjectOnly" @change="onTypChange" />
                            </el-form-item>
                            <!-- 專案(2) -->
                            <div v-if="form.typ === 2">
                                <el-form-item label="專案">
                                    <el-input :value="selectedProject.nam" disabled />
                                </el-form-item>
                            </div>
                            <!-- 特定費用項目(3) -->
                            <el-form-item v-if="form.typ === 3" prop="poo" label="特定費用項目">
                                {{ selectedSpecialProjectSno }}
                                <el-select
                                    v-model="form.poo"
                                    placeholder="請選擇"
                                    no-data-text="無專案"
                                    no-match-text="無匹配專案"
                                    value-key="sno"
                                    filterable
                                    class="project-select"
                                    @change="onProjectChange"
                                >
                                    <el-option v-for="item in specialProjectList" :key="item.poo" :label="item.nam" :value="item.poo" />
                                </el-select>
                            </el-form-item>
                            <!-- 經常性支出項目(4) -->
                            <el-form-item v-if="form.typ === 4" prop="ofeN_ITEM_SNO" label="經常性支出項目">
                                <el-select name="type" v-model="form.ofeN_ITEM_SNO" placeholder="請選擇" no-data-text="無項目" style="width: 100%" @change="onOftenProjectChange" filterable>
                                    <el-option v-for="item in oftenProjectList" :key="item.sno" :label="item.iteM_NAM" :value="item.sno" />
                                </el-select>
                                <el-alert v-if="activeExpendAmtSpan" type="warning" style="padding: 0px 5px 5px 10px; margin-top: 10px; line-height: 150%" :closable="false">
                                    金額範圍：{{ activeExpendAmtSpan.min }} ~ {{ activeExpendAmtSpan.max }}
                                </el-alert>
                            </el-form-item>
                            <el-form-item prop="dat" label="請款單日期">
                                <el-date-picker v-model="form.dat" type="date" value-format="timestamp" placeholder="選擇日期"> </el-date-picker>
                            </el-form-item>
                            <el-form-item prop="nam" label="請款摘要">
                                <ah-flex-input v-model="form.nam" :maxlength="150" />
                            </el-form-item>
                            <el-form-item label="委外勞務">
                                <el-tooltip content="勞報單欄位" placement="top">
                                    <el-input v-model="payeeNam" disabled style="max-width: 310px" />
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item prop="os_MEM" label="請款勞務內容">
                                <el-input v-model="form.oS_MEM" type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="1000" :show-word-limit="true"></el-input>
                            </el-form-item>
                            <el-form-item prop="serviceType" label="所得類別">
                                <el-tooltip content="勞報單欄位" placement="top">
                                    <el-input :value="getIncomeType(form.serviceType)" disabled style="max-width: 310px" />
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item prop="serviceSubType" label="業別代號">
                                <el-tooltip content="勞報單欄位" placement="top">
                                    <el-input :value="getServiceType(form.serviceSubType)" disabled style="max-width: 310px" />
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item prop="amt" label="應付總額" style="margin-top: 30px">
                                <template slot="label">應付總額<ah-tip>以報酬金額加總</ah-tip></template>
                                <el-tooltip content="勞報單欄位" placement="top">
                                    <el-input :value="form.cny" disabled style="width: 120px; margin-right: 5px" />
                                </el-tooltip>
                                <el-tooltip content="勞報單欄位" placement="top">
                                    <money-input
                                        v-model="form.amt"
                                        disabled
                                        :precision="form.cny == 'TWD' ? 0 : 4"
                                        @change="onChangeAmt"
                                        style="width: 250px"
                                        :suffix="form.cny === 'TWD' ? '元' : form.cny"
                                    />
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item v-if="form.cny !== 'TWD'" prop="paY_CNYRAT" label="約定匯率" style="margin-bottom: 45px">
                                <money-input v-model="form.paY_CNYRAT" :precision="4" style="max-width: 120px; margin-right: 5px" @change="onCnyRatChange" />
                                <money-input v-model="twdAmt" disabled style="width: 250px" suffix="約當台幣" />
                            </el-form-item>
                            <!-- 委外勞務：代扣 -->
                            <template v-if="form.paY_TO === 3">
                                <el-form-item>
                                    <div v-if="form.serviceType === 1 || form.serviceType === 2">
                                        <ah-outsourcing-personal-tax-info :incomeType="form.serviceType" />
                                    </div>
                                </el-form-item>
                                <el-form-item label="選擇多單代扣計算">
                                    <el-radio v-model="taxCountMethod" label="sum" @change="onTaxCountMethodChange">依轉送勞報單代扣總計代入</el-radio>
                                    <el-radio v-model="taxCountMethod" label="recount" @change="onTaxCountMethodChange">以報酬金額加總，重新計算代扣</el-radio>
                                </el-form-item>
                                <el-form-item v-if="taxCountMethod === 'recount'" label="自動計算扣繳率">
                                    <el-switch v-model="isEnableAutoTax" @change="onChangeEnableAutoTax"></el-switch>
                                    <span v-if="!isEnableAutoTax">（請手動編輯扣繳率）</span>
                                </el-form-item>
                                <el-form-item prop="taX_AMT" label="− 代扣所得稅款">
                                    <money-input
                                        v-model="taxRatio"
                                        :disabled="taxCountMethod === 'sum' || isEnableAutoTax"
                                        style="width: 120px; margin: 0 5px 0 0"
                                        :precision="2"
                                        @change="onChangeTaxRatio"
                                        suffix="%"
                                    />
                                    <money-input
                                        v-model="form.taX_AMT"
                                        :disabled="taxCountMethod === 'sum'"
                                        @change="onChangeTaxAmt"
                                        style="width: 180px"
                                        :suffix="form.cny === 'TWD' ? '元' : 'TWD'"
                                    />
                                    <template v-if="form.cny !== 'TWD'">
                                        <money-input v-model="taxAmtInOriginCny" :precision="2" :suffix="form.cny" style="width: 180px; margin-left: 5px" disabled />
                                        <ah-rich-pop-info :width="430" title="代扣所得稅款（外幣）">
                                            <template slot="content">
                                                <div style="text-align: left">
                                                    <div>= ((應付總額 * 約定匯率) * 代扣所得稅率) / 約定匯率</div>
                                                    <div>= (({{ form.amt.toLocaleString() }} * {{ form.paY_CNYRAT }}) * {{ taxRatio }}%) / {{ form.paY_CNYRAT }}</div>
                                                    <div>= {{ taxAmtInOriginCny.toLocaleString() }}</div>
                                                </div>
                                            </template>
                                            <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                        </ah-rich-pop-info>
                                    </template>
                                </el-form-item>
                                <el-form-item prop="geN2_AMT" label="− 代扣二代健保">
                                    <money-input
                                        v-model="gen2Ratio"
                                        :disabled="taxCountMethod === 'sum' || isEnableAutoTax"
                                        style="width: 120px; margin: 0 5px 0 0"
                                        :precision="2"
                                        @change="onChangeGen2Ratio"
                                        suffix="%"
                                    ></money-input>
                                    <money-input
                                        v-model="form.geN2_AMT"
                                        :disabled="taxCountMethod === 'sum'"
                                        @change="onChangeGen2Amt"
                                        style="width: 180px"
                                        :suffix="form.cny === 'TWD' ? '元' : 'TWD'"
                                    />
                                    <template v-if="form.cny !== 'TWD'">
                                        <money-input v-if="form.cny !== 'TWD'" v-model="gen2AmtInOriginCny" :precision="2" :suffix="form.cny" style="width: 180px; margin-left: 5px" disabled />
                                        <ah-rich-pop-info :width="450" title="代扣二代健保（外幣）">
                                            <template slot="content">
                                                <div style="text-align: left">
                                                    <div>= ((應付總額 * 約定匯率) * 代扣二代健保費率) / 約定匯率</div>
                                                    <div>= (({{ form.amt.toLocaleString() }} * {{ form.paY_CNYRAT }}) * {{ gen2Ratio }}%) / {{ form.paY_CNYRAT }}</div>
                                                    <div>= {{ gen2AmtInOriginCny.toLocaleString() }}</div>
                                                </div>
                                            </template>
                                            <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                        </ah-rich-pop-info>
                                    </template>
                                </el-form-item>
                                <el-form-item label="＝ 實付金額">
                                    <div v-if="form.cny !== 'TWD'" style="margin-bottom: 5px">
                                        <money-input v-model="realPayAmtInOriginCny" disabled style="width: 305px" :precision="2" :suffix="form.cny" />
                                        <ah-rich-pop-info :width="550" title="實付金額（外幣）">
                                            <template slot="content">
                                                <div style="text-align: left">
                                                    <!-- (Math.round(this.form.amt * this.form.paY_CNYRAT) - this.form.taX_AMT - this.form.geN2_AMT) / this.form.paY_CNYRAT; -->
                                                    <div>= ((外幣應付總額 * 約定匯率) - 代扣所得稅款(台幣) - 代扣二代健保(台幣)) / 約定匯率</div>
                                                    <div>
                                                        = (({{ form.amt.toLocaleString() }} * {{ form.paY_CNYRAT }}) - {{ form.taX_AMT.toLocaleString() }} - {{ form.geN2_AMT.toLocaleString() }}) /
                                                        {{ form.paY_CNYRAT }}
                                                    </div>
                                                    <div>= {{ realPayAmtInOriginCny.toLocaleString() }}</div>
                                                </div>
                                            </template>
                                            <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                        </ah-rich-pop-info>
                                    </div>
                                    <div>
                                        <money-input v-model="realPayAmtTwd" disabled style="width: 305px" :suffix="form.cny === 'TWD' ? '元' : '約當台幣'" />
                                        <ah-rich-pop-info v-if="form.cny === 'TWD'" :width="350" title="實付金額">
                                            <template slot="content">
                                                <div style="text-align: left">
                                                    <div>= 應付總額 - 代扣所得稅款 - 代扣二代健保</div>
                                                    <div>= {{ form.amt.toLocaleString() }} - {{ form.taX_AMT.toLocaleString() }} - {{ form.geN2_AMT.toLocaleString() }}</div>
                                                    <div>= {{ realPayAmtTwd.toLocaleString() }}</div>
                                                </div>
                                            </template>
                                            <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                        </ah-rich-pop-info>
                                        <ah-rich-pop-info v-if="form.cny !== 'TWD'" :width="550" title="實付金額（約當台幣）">
                                            <template slot="content">
                                                <div style="text-align: left">
                                                    <div>= (外幣應付總額 * 約定匯率) - 代扣所得稅款(台幣) - 代扣二代健保(台幣)</div>
                                                    <div>= ({{ form.amt.toLocaleString() }} * {{ form.paY_CNYRAT }}) - {{ form.taX_AMT.toLocaleString() }} - {{ form.geN2_AMT.toLocaleString() }}</div>
                                                    <div>= {{ realPayAmtTwd.toLocaleString() }}</div>
                                                </div>
                                            </template>
                                            <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                        </ah-rich-pop-info>
                                    </div>
                                </el-form-item>
                            </template>
                            <el-form-item v-if="isFullAuditFlow" prop="pdat" label="預計付款日期">
                                <el-date-picker v-model="form.pdat" value-format="timestamp" type="date" placeholder="請選擇"></el-date-picker>
                            </el-form-item>
                            <el-form-item label="預計付款方式" v-if="isFullAuditFlow">
                                <!-- 付款方式選項 -->
                                <el-radio-group name="user-pay-way" v-model="form.useR_PAY_WAY">
                                    <el-radio-button :label="1" id="payment-add-page-pay-way-cash" :disabled="form.cny !== 'TWD'"> 零用現金 </el-radio-button>
                                    <el-radio-button v-if="!isFullAuditFlow" :label="3"> 銀行提現 </el-radio-button>
                                    <el-tooltip placement="top" content="申請人已選擇零用現金，若需改為銀行轉帳，請退件，由申請人填寫收款銀行資訊。" :manual="!isDisableBankTransfer">
                                        <el-radio-button :label="2" :disabled="isDisableBankTransfer"> 銀行轉帳 </el-radio-button>
                                    </el-tooltip>
                                </el-radio-group>
                                <!-- 自訂流程，付款提示 -->
                                <template v-if="isFullAuditFlow">
                                    <el-alert v-if="form.useR_PAY_WAY == 1" :closable="false" type="warning" style="line-height: 160%; margin-top: 10px">
                                        <span>請與公司財務確認付款方式為零用現金付款</span>
                                    </el-alert>
                                </template>
                            </el-form-item>
                        </div>
                    </div>

                    <!-- 付款面板（簡易流程） -->
                    <div v-if="!isFullAuditFlow" class="ah-panel">
                        <div class="panel-header small">
                            <div class="panel-title">付款資訊</div>
                        </div>
                        <div class="panel-body">
                            <div class="form-section" style="margin-bottom: 50px">
                                <div class="form-section-title">實付金額</div>
                                <el-form-item prop="paY_DAT" label="付款日">
                                    <el-date-picker v-model="form.paY_DAT" value-format="timestamp" type="date" placeholder="請選擇"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="付款方式">
                                    <!-- 付款方式選項 -->
                                    <el-radio-group name="user-pay-way" v-model="form.useR_PAY_WAY">
                                        <el-radio-button :label="1" id="payment-add-page-pay-way-cash" :disabled="form.cny !== 'TWD'"> 零用現金 </el-radio-button>
                                        <el-radio-button v-if="!isFullAuditFlow" :label="3"> 銀行提現 </el-radio-button>
                                        <el-tooltip placement="top" content="申請人已選擇零用現金，若需改為銀行轉帳，請退件，由申請人填寫收款銀行資訊。" :manual="!isDisableBankTransfer">
                                            <el-radio-button :label="2" :disabled="isDisableBankTransfer"> 銀行轉帳 </el-radio-button>
                                        </el-tooltip>
                                    </el-radio-group>
                                    <!-- 簡易流程，付款提示 -->
                                    <template>
                                        <el-alert v-if="form.useR_PAY_WAY === 1" :closable="false" type="warning" style="line-height: 160%; margin-top: 10px">
                                            <span>即時零用現金餘額：</span><Money :v="currCash" />
                                        </el-alert>
                                        <el-alert v-if="form.useR_PAY_WAY === 2 || form.useR_PAY_WAY === 3" :closable="false" type="warning" style="line-height: 160%; margin-top: 10px">
                                            <span>如有產生手續費，請至「銀行匯款明細、匯費」填寫匯費金額。</span>
                                        </el-alert>
                                    </template>
                                </el-form-item>
                                <el-form-item v-if="isShowPayBnk" prop="paY_BNK_SNO" label="轉出帳戶">
                                    <ah-el-select-bank-account v-model="form.paY_BNK_SNO" document-type="payment" :cny="form.cny" hide-borrower :show-balance="this.isAuth('A02')">
                                    </ah-el-select-bank-account>
                                </el-form-item>
                                <el-form-item prop="iteM_SNO" v-if="!isFullAuditFlow" label="支出項目">
                                    <template slot="label"> 支出項目 <ahTip>用於財務分析的分類</ahTip> </template>
                                    <ahSelectVariableStateItem v-model="form.iteM_SNO" :enableType="['payout']" @change="onVariableStateItemChange" hideTip></ahSelectVariableStateItem>
                                </el-form-item>
                                <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="accno" label="立帳科目">
                                    <ahSuggestAccountingItemsSelector
                                        ref="ahSuggestAccountingItemsSelector"
                                        v-model="form.accno"
                                        @loaded="onAhSuggestAccountingItemsSelectorLoaded"
                                    ></ahSuggestAccountingItemsSelector>
                                </el-form-item>
                                <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="clearanceAccno" label="沖帳科目">
                                    <ah-select-accounting-setting v-model="form.clearanceAccno" width="200px" :allowedGroups="['liabilitiesSettings', 'noeSettings']" />
                                </el-form-item>
                            </div>
                            <el-row :gutter="20">
                                <el-col :md="12">
                                    <div class="form-section-title">代扣所得稅</div>
                                    <el-form-item prop="taX_PAY_DAT" label="代扣所得稅繳款日" :rules="form.taX_AMT === 0 ? [] : rules.taX_PAY_DAT">
                                        <template v-if="form.taX_AMT === 0">（無）</template>
                                        <template v-if="form.taX_AMT !== 0">
                                            <el-date-picker v-model="form.taX_PAY_DAT" type="date" value-format="timestamp" placeholder="選擇日期" style="width: 200px"></el-date-picker>
                                            <div v-if="isTaxPayDateInvalid" class="date-warning"><i class="el-icon-warning-outline"></i>應於實際付款日之後</div>
                                        </template>
                                    </el-form-item>
                                    <el-form-item prop="taX_BNK_SNO" label="代扣所得稅付款帳戶" :rules="form.taX_AMT === 0 ? [] : rules.taX_BNK_SNO">
                                        <template v-if="form.taX_AMT === 0">（無）</template>
                                        <template v-if="form.taX_AMT !== 0">
                                            <ah-el-select-bank-account v-model="form.taX_BNK_SNO" document-type="payment" cny="TWD" hide-borrower allow-cash></ah-el-select-bank-account>
                                        </template>
                                    </el-form-item>
                                </el-col>
                                <el-col :md="12">
                                    <div class="form-section-title">代扣二代健保</div>
                                    <el-form-item prop="geN2_PAY_DAT" label="代扣二代健保繳款日" :rules="form.geN2_AMT === 0 ? [] : rules.geN2_PAY_DAT">
                                        <template v-if="form.geN2_AMT === 0">（無）</template>
                                        <template v-if="form.geN2_AMT !== 0">
                                            <el-date-picker v-model="form.geN2_PAY_DAT" type="date" value-format="timestamp" placeholder="選擇日期" style="width: 200px"></el-date-picker>
                                            <div v-if="isGen2PayDateInvalid" class="date-warning">
                                                <i class="el-icon-warning-outline"></i>
                                                應於實際付款日之後
                                            </div>
                                        </template>
                                    </el-form-item>
                                    <el-form-item prop="geN2_BNK_SNO" label="代扣二代健保付款帳戶" :rules="form.geN2_AMT === 0 ? [] : rules.geN2_BNK_SNO">
                                        <template v-if="form.geN2_AMT === 0">（無）</template>
                                        <template v-if="form.geN2_AMT !== 0">
                                            <ah-el-select-bank-account v-model="form.geN2_BNK_SNO" document-type="payment" cny="TWD" hide-borrower allow-cash></ah-el-select-bank-account>
                                        </template>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <!-- 收款資訊 -->
                    <div class="ah-panel">
                        <div class="panel-header small">
                            <div class="panel-title">收款資訊</div>
                        </div>
                        <div class="panel-body">
                            <template v-if="form.useR_PAY_WAY === 2">
                                <el-form-item prop="accountType" label="帳戶類型">
                                    <el-radio-group v-model="form.accountType" disabled>
                                        <el-radio :label="1">本國帳戶</el-radio>
                                        <el-radio :label="2">外國帳戶</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="form.accountType === 1" prop="vdR_BNK_BOO" label="收款銀行">
                                    <el-tooltip content="勞報單欄位" placement="top">
                                        <ah-el-select-bank v-model="form.vdR_BNK_BOO" :branch="form.vdR_BNK_DOO" :disabled="true" @branchInput="form.vdR_BNK_DOO = $event" />
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item v-if="form.accountType === 2" prop="abroadBankName" label="銀行名稱（英文）">
                                    <el-tooltip content="勞報單欄位" placement="top">
                                        <el-input v-model="form.abroadBankName" disabled :maxlength="40" :show-word-limit="true"></el-input>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item v-if="form.accountType === 2" prop="swiftCode" label="SWIFT Code">
                                    <el-tooltip content="勞報單欄位" placement="top">
                                        <el-input v-model="form.swiftCode" disabled style="max-width: 500px" :maxlength="40" :show-word-limit="true"></el-input>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item prop="vdR_BNK_TPC" label="存摺戶名">
                                    <el-tooltip content="勞報單欄位" placement="top">
                                        <el-input v-model="form.vdR_BNK_TPC" disabled :maxlength="30" :show-word-limit="true" />
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item prop="vdR_BNK_ACC" label="收款帳號">
                                    <el-tooltip content="勞報單欄位" placement="top">
                                        <ah-el-input-bank-acc v-model="form.vdR_BNK_ACC" :bankBoo="form.vdR_BNK_BOO" disabled />
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item prop="vdR_BNK_NOTE" label="帳戶備註">
                                    <el-tooltip content="勞報單欄位" placement="top">
                                        <el-input v-model="form.vdR_BNK_NOTE" disabled :maxlength="50" :show-word-limit="true" />
                                    </el-tooltip>
                                </el-form-item>
                            </template>
                            <el-form-item prop="vdR_NAM" label="聯絡人">
                                <el-tooltip content="綁定勞報單欄位" placement="top">
                                    <el-input v-model="form.vdR_NAM" disabled style="max-width: 300px" :maxlength="20" :show-word-limit="true"></el-input>
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item prop="vdR_TEL" label="聯絡電話">
                                <el-tooltip content="綁定勞報單資訊" placement="top">
                                    <el-input v-model="form.vdR_TEL" disabled style="max-width: 500px" :maxlength="20" :show-word-limit="true"></el-input>
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item prop="vdR_EML" label="聯絡信箱">
                                <el-tooltip content="勞報單欄位" placement="top">
                                    <el-input v-model="form.vdR_EML" disabled style="max-width: 500px" :maxlength="50" :show-word-limit="true"></el-input>
                                </el-tooltip>
                            </el-form-item>
                        </div>
                    </div>

                    <!-- 檢附單據 -->
                    <div class="ah-panel">
                        <div class="panel-header small">
                            <div class="panel-title">檢附單據</div>
                        </div>
                        <div class="panel-body">
                            <el-form-item prop="toBeAddFile" label="待補單據標示">
                                <el-checkbox v-model="form.toBeAddFile">(將此請款單標示為"待補單據")</el-checkbox>
                            </el-form-item>
                            <el-form-item prop="" label="單據列表">
                                <ReceiptUploadInput v-model="form.files" :isShowTaxStatus="false" :cny="form.cny" />
                                <el-alert show-icon :closable="false" style="margin-top: 5px; line-height: 100%">
                                    <div style="font-size: 9.5pt; padding-bottom: 5px">
                                        <div>建議上傳已回簽的勞報單PDF</div>
                                    </div>
                                </el-alert>
                            </el-form-item>
                            <el-form-item prop="">
                                <template slot="label"> 單據總額(含稅)<ahTip>使用請款相同幣別</ahTip> </template>
                                <span>
                                    <Money :v="receiptAmtTotal" :round="form.cny === 'TWD'" />
                                    {{ form.cny }}</span
                                >
                                <el-alert
                                    type="warning"
                                    style="display: inline-block; vertical-align: top; line-height: initial; padding: 3px 8px 6px 8px; margin: 0 0 0 5px; width: 180px"
                                    :closable="false"
                                    v-if="form.amt != receiptAmtTotal"
                                >
                                    單據總額與付款金額不相符
                                </el-alert>
                            </el-form-item>
                        </div>
                    </div>

                    <!-- 送出 -->
                    <center>
                        <el-button v-if="form.sno" @click="onDelete" type="danger">作廢請款單</el-button>
                        <el-button @click="onClose">取消</el-button>
                        <el-button type="primary" class="primary-action" :loading="isSubmitting" id="payment-add-page-submit-btn" @click="onSubmit">送出</el-button>
                    </center>
                </template>
            </div>
        </el-form>
        <SelectDialog :visible="selectDialog.visible" :selectedList="selectedServiceFeeList" :payeeName="selectDialog.payeeName" @submit="onSelectDialogSubmit" @close="onSelectDialogClose" />
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import {
    serviceFeeStatementType, serviceTypeList, serviceType9AList, serviceType9BList,
} from '@/assets/commonData/options';
import confirm from '@/utils/confirm';
import { getTaxAmtInfo, getGen2AmtInfo } from '@/utils/OutsourcingPersonalTaxHelpers';
import ahFlexInput from '@/components/ui/ahFlexInput.vue';
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahSuggestAccountingItemsSelector from '@/components/ui/ahSuggestAccountingItemsSelector.vue';
import ahOutsourcingPersonalTaxInfo from '@/components/ui/ahOutsourcingPersonalTaxInfo.vue';
import ReceiptUploadInput from '@/components/ui/ReceiptUploadInput.vue';
import SelectDialog from '@/components/dashboard/ServiceFeeStatement/SelectDialog.vue';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';
import SelectedServiceFeeTable from './SelectedServiceFeeTable.vue';
import PaymentTypeSelect from './PaymentTypeSelect.vue';

export default {
    components: {
        ahElSelectBank,
        ahElInputBankAcc,
        ahElSelectBankAccount,
        ahSelectVariableStateItem,
        ahSuggestAccountingItemsSelector,
        ahOutsourcingPersonalTaxInfo,
        ReceiptUploadInput,
        SelectDialog,
        SelectedServiceFeeTable,
        PaymentTypeSelect,
        ahFlexInput,
        ahSelectAccountingSetting,
    },
    data() {
        return {
            isAhSuggestAccountingItemsSelectorShow: false,
            currCash: null,

            form: {
                // 請款單欄位
                dat: +moment().startOf('day').format('x'),
                typ: 1,
                nam: '',
                amt: 0,
                geN2_CHK: false, // 是否扣二代健保
                geN2_AMT: 0, // 二代健保金額
                taX_CHK: false, // 是否扣勞務稅額
                taX_AMT: 0, // 勞務稅額金額
                useR_PAY_WAY: 2,
                pdat: null,
                filE_ATT: null, // 單據檔案
                paY_TO: 3, // 付款對象 1=申請人,2=廠商,3=個人勞務,4=外國
                paY_NAM: '', // 外幣收款人名
                paY_COUNRTY: '', // 外幣收款人國家
                vdR_SNO: null,
                vdR_BNK_SNO: null,
                poo: null, // 專案編號, 特定費用項目編號
                ofeN_ITEM_SNO: null, // 經常性支出項目編號
                cny: 'TWD',
                paY_STF_SNO: null,
                vdR_BNK_BOO: null,
                vdR_BNK_DOO: null,
                vdR_BNK_ACC: null,
                vdR_BNK_TPC: null,
                vdR_BNK_NOTE: null,
                vdR_NAM: null,
                vdR_TEL: null,
                vdR_EML: null,
                accountType: 1,
                vdR_ABD: 0, // 國籍
                abd: 0, // 委外勞務-國籍: 0=本國, 1=外國籍在台已滿183天, 2=外國籍在台未滿183天；委外廠商-國籍：0=本國, 1=外國
                abD_TYP: null, // 境外廠商身份
                abroadBankName: null, // 境外銀行
                swiftCode: null, // 境外swift code

                paY_CNYRAT: 1, // 當下匯率(外幣使用)

                paY_DAT: null, // (簡易流程) 付款日期
                paY_WAY: null, // (簡易流程) 付款方式
                paY_BNK_SNO: null, // (簡易流程) 付款銀行帳號
                taX_BNK_SNO: null, // (簡易流程) 代扣所得稅額付款帳戶
                taX_PAY_DAT: null, // (簡易流程) 代扣所得稅付款日期
                taX_PAY_WAY: null, // (簡易流程) 代扣所得稅額付款方式（前端不顯示）
                geN2_BNK_SNO: null, // (簡易流程) 代扣二代健保付款帳戶
                geN2_PAY_DAT: null, // (簡易流程) 代扣二代健保付款日期
                geN2_PAY_WAY: null, // (簡易流程) 代扣二代健保付款方式（前端不顯示）
                iteM_SNO: null, // (簡易流程) 支出項目
                accno: null, // (簡易流程) 會計科目
                clearanceAccno: null, // (簡易流程) 沖帳科目

                f_FOO: '',
                f_DAT: null,
                f_NAM: ' ',
                test: 0,
                oS_MEM: null, // 工作內容

                files: [],
                toBeAddFile: false,
                serviceSubType: null,

                // 其他
                projectSno: null,
                caT_SNO: null,
                nationality: 0,
                idTyp: 0,
                bsn: null,
                payee: null,
                phone: null,
                email: null,
                permanentAddrCty: null,
                permanentAddr: null,
                contactAddrCty: null,
                contactAddr: null,
                idCardFront: null,
                idCardBack: null,
                unionInsuranceDoc: null,
                passbookDoc: null,

                serviceType: null,
                otherServiceType: null,
                unionInsuranceExpireDate: null,
                realPayAmt: 0,

                permanentAddrAra: null,
                contactAddrAra: null,
            },
            rules: {
                nam: [{ required: true, message: '請輸入請款摘要' }],
                poo: [{ required: true, message: '請輸入特定費用項目' }],
                ofeN_ITEM_SNO: [{ required: true, message: '請輸入經常性支出項目' }],
                paY_DAT: [{ required: true, message: '請輸入付款日' }],
                dat: [{ required: true, message: '請輸入請款單日期' }],
                serviceType: [{ required: true, message: '請輸入所得類別' }],
                // serviceSubType: [{ required: true, message: '請輸入業別代號' }],
                amt: [{ required: true, message: '請輸入應付總額' }],
                paY_BNK_SNO: [{ required: true, message: '請選擇轉出帳戶', trigger: 'change' }],
                iteM_SNO: [{ required: true, message: '請選擇支出項目', trigger: 'change' }],
                accno: [{ required: true, message: '請選擇會計科目', trigger: 'change' }],
                taX_PAY_DAT: [{ required: true, message: '請選擇代扣所得稅繳款日', trigger: 'change' }],
                taX_BNK_SNO: [{ required: true, message: '請選擇代扣所得稅付款帳戶', trigger: 'change' }],
                geN2_PAY_DAT: [{ required: true, message: '請選擇代扣二代健保繳款日', trigger: 'change' }],
                geN2_BNK_SNO: [{ required: true, message: '請選擇代扣二代健保付款帳戶', trigger: 'change' }],
            },

            // Flags
            isExitedOutsourcing: true,
            isSameAsPermanentAddr: false,
            isLoading: false,
            isSubmitting: false,

            // 選項
            projectList: [],
            specialProjectList: [],
            oftenProjectList: [],
            outsourcingList: [],
            serviceFeeStatementType,
            auditFlowSetting: {},

            // TEMP
            selectedServiceFeeList: [], // 已選取的勞務單陣列
            selectedProject: null, // 已選取的專案
            taxRatio: 10, // 勞務稅%
            gen2Ratio: 2.11, // 二代健保%
            payeeNam: null, // 委外勞務姓名
            selectedBnk: null,
            selectedOftenProjectDetail: null,
            selectedSpecialProjectSno: null, // 以選取的特別費用
            taxAmtInOriginCny: 0,
            gen2AmtInOriginCny: 0,
            realPayAmtTwd: 0,
            realPayAmtInOriginCny: 0,
            isEnableAutoTax: true, // 自動啟用勞務稅/二代健保
            isProjectOnly: false, // 是否限定專案請款
            hasUnionInsurance: false,
            taxCountMethod: 'sum', // 代扣計算方式 sum, recount

            //
            selectDialog: {
                visible: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
            userSno: 'account/userSno',
            cnyOptions: 'cny/cnyOptions',
        }),
        isRejectedMode() {
            return this.$route.params.sno && this.form.sigN_STS === 4;
        },
        twdAmt() {
            return Math.round(this.form.amt * this.form.paY_CNYRAT);
        },
        // isLaborTaxShow() {
        //     if (this.form.serviceType !== 3) return Math.floor(this.form.amt * this.form.paY_CNYRAT * 0.1) > TAX_THRESHOLD;
        //     return Math.floor(this.form.amt * this.form.paY_CNYRAT) >= 86001;
        // },
        // isGen2Show() {
        //     const THRESHOLD = this.form.serviceSubType === 3 ? 26400 : 20000;
        //     return this.form.amt * this.form.paY_CNYRAT >= THRESHOLD;
        // },
        isShowCnyRat() {
            return this.form.cny !== 'TWD' && !this.isFullAuditFlow && this.form.useR_PAY_WAY === 2;
        },

        // 業務類別選項
        serviceSubTypeOption() {
            switch (this.form.serviceType) {
            case 1:
                return serviceType9AList;
            case 2:
                return serviceType9BList;
            default:
                return [];
            }
        },

        projectSelectTitle() {
            switch (this.form.typ) {
            case 2:
                return '專案';
            case 3:
                return '特定費用項目';
            case 4:
                return '特許支出';
            default:
                return '';
            }
        },
        // 經常性支出金額範圍
        activeExpendAmtSpan() {
            const vproject = this.oftenProjectList.find((obj) => obj.sno === this.form.ofeN_ITEM_SNO);
            return vproject ? { min: vproject.amT_S, max: vproject.amT_E } : null;
        },

        isShowPayBnk() {
            // 簡易流程 && 銀行付款
            if (!this.isFullAuditFlow && this.form.useR_PAY_WAY !== 1) {
                return true;
            }

            return false;
        },
        // 簡易審核流程
        isFullAuditFlow() {
            // 特定費用：讀取特定費用項目的審核流程
            if (this.form.typ === 3) {
                const proj = this.specialProjectList.find((x) => x.poo === this.form.poo);
                if (proj) {
                    return proj.sP_FLAG;
                }
                return true;
            }
            // 經常性支出：讀取經常性支出的審核流程
            if (this.form.typ === 4) {
                const item = this.oftenProjectList.find((x) => x.sno === this.form.ofeN_ITEM_SNO);
                if (item) {
                    return item.ofteN_FLAG;
                }
                return true;
            }
            // 專案
            if (this.form.typ === 2) {
                if (this.auditFlowSetting.projectAuditFlowSetting) {
                    return this.auditFlowSetting.projectAuditFlowSetting.isEnable;
                }
                return false;
            }
            // 一般、外幣 請款，使用設定裡的流程開關
            if (this.form.typ === 1 || this.form.typ === 5) {
                if (this.auditFlowSetting.payoutAuditFlowSetting) {
                    return this.auditFlowSetting.payoutAuditFlowSetting.isEnable;
                }
                return false;
            }
            // 錯誤

            return null;
        },

        // 是否禁止付款方式切換為銀行轉帳
        isDisableBankTransfer() {
            return this.payment?.useR_PAY_WAY === 1;
        },

        isTaxPayDateInvalid() {
            return this.form.taX_PAY_DAT !== null && this.form.taX_PAY_DAT < this.form.paY_DAT;
        },

        isGen2PayDateInvalid() {
            return this.form.geN2_PAY_DAT !== null && this.form.geN2_PAY_DAT < this.form.paY_DAT;
        },

        // 審核流程判斷
        currentFlow() {
            if (this.form.typ === 1 || this.form.typ === 5) {
                return this.auditFlowSetting.payoutAuditFlowSetting?.settings;
            }
            if (this.form.typ === 2) {
                return this.auditFlowSetting.projectAuditFlowSetting?.settings;
            }
            return [];
        },

        // 檢查流程是否有空缺
        isFlowValidate() {
            if (!this.isFullAuditFlow) return true;
            let isValidated = false;
            const amt = this.form.amt * this.form.paY_CNYRAT;

            if (this.currentFlow?.length) {
                this.currentFlow?.forEach((item) => {
                    if (amt >= item.startAmount && amt <= item.endAmount) {
                        isValidated = true;
                    }
                });
            } else isValidated = true;

            return isValidated;
        },

        // 單據總額
        receiptAmtTotal() {
            const SUM = _.chain(this.form.files)
                .filter((o) => !o.delete)
                .sumBy('amt')
                .value();
            return Math.round(SUM * 100) / 100;
        },
    },
    async mounted() {
        // 取得會計科目列表
        await this.$store.dispatch('accounting/updateAccountingSettings');
        // 取得審核流程，用來判斷是否為簡易流程
        this.auditFlowSetting = await this.fetchAuditFlow();

        // 取得零用金餘額，用於顯示出餘額
        this.currCash = await this.fetchCash();

        if (this.$route.query.list) {
            // 網址列有勾選的勞務單清單，取得勾選的勞務單資料
            const snoListTxt = this.$route.query.list.toString();
            const serviceFeeSnoList = snoListTxt.split(',');
            if (serviceFeeSnoList && serviceFeeSnoList.length > 0) {
                // 已成功取得的勞務單資料陣列
                this.selectedServiceFeeList = await this.fetchServiceFeeStatementList(serviceFeeSnoList);

                // 填入請款資料
                this.fillPaymentFields(this.selectedServiceFeeList, null);
            }
            return;
        }
        // 退件編輯
        if (this.$route.params.sno) {
            // 取得原請款單資料
            const paymentData = await this.fetchPaymentData();

            // 取得勞報單資料
            const serviceFeeSnoList = _.map(paymentData.serviceFeeStatement, 'sno');
            if (serviceFeeSnoList && serviceFeeSnoList.length > 0) {
                this.selectedServiceFeeList = await this.fetchServiceFeeStatementList(serviceFeeSnoList);

                // 載入特別費用列表
                if (paymentData.typ === 3) this.fetchSpecialProjectList();

                // 經常性支出
                if (paymentData.typ === 4) this.fetchOftenOptions();

                // 填入請款資料
                this.fillPaymentFields(this.selectedServiceFeeList, paymentData);
            }
        } else {
            console.log('無預選勞務單');
        }
    },
    methods: {
        // 取得一批勞報單
        async fetchServiceFeeStatementList(snoList) {
            this.isLoading = true;
            const list = [];
            for (let i = 0; i < snoList.length; i += 1) {
                // eslint-disable-next-line no-await-in-loop
                const serviceFeeData = await this.fetchServiceFeeStatement(snoList[i]);
                if (serviceFeeData) list.push(serviceFeeData);
            }
            this.isLoading = false;
            // 使用 sno 重新排列小到大
            list.sort((a, b) => a.sno - b.sno);
            return list;
        },

        // 取得單張勞報單
        async fetchServiceFeeStatement(sno) {
            try {
                const resp = await this.$api({
                    url: 'ServiceOrder/GetServiceFeeStatement',
                    method: 'GET',
                    params: { sno },
                });
                return resp.data.item;
            } catch (e) {
                console.log(e);
                return null;
            }
        },

        // 取得請款單資料（）
        async fetchPaymentData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: '/PaymentManagenmentPage/GetPaymentInfo',
                    method: 'GET',
                    params: { sno: this.$route.params.sno },
                });

                console.log('Payment Detail: ', resp.data.item);
                return resp.data.item;
                // this.form.taX_BNK_SNO = resp.data.item.taX_PAY_WAY === 1 ? -1 : this.form.taX_BNK_SNO;
                // this.form.geN2_BNK_SNO = resp.data.item.geN2_PAY_WAY === 1 ? -1 : this.form.geN2_BNK_SNO;
            } catch (e) {
                console.log(e);
                return null;
            } finally {
                this.isLoading = false;
            }
        },
        async fetchCash() {
            try {
                const resp = await this.$api({
                    url: '/Tool/GetCashBalance',
                    method: 'GET',
                });
                return resp.data.balance;
            } catch (e) {
                console.log(e);
                return null;
            }
        },
        // 載入設定裡的請款流程
        async fetchAuditFlow() {
            try {
                const resp = await this.$api({
                    url: '/Tool/GetAuditFlowTemplates',
                    method: 'GET',
                });
                return resp.data;
            } catch (e) {
                console.log(e);
                return null;
            }
        },

        // 取得特定費用項目列表
        async fetchSpecialProjectList() {
            try {
                const resp = await this.$api({
                    url: 'PaymentManagenmentPage/GetProjectOptions?Type=2',
                    method: 'GET',
                });
                this.specialProjectList = resp.data.options;
            } catch (e) {
                console.log(e);
            }
        },

        // 取得經常性支出列表
        async fetchOftenOptions() {
            try {
                const resp = await this.$api({
                    url: 'PaymentManagenmentPage/GetOftenOptions',
                    method: 'GET',
                });
                this.oftenProjectList = resp.data.options;
            } catch (e) {
                console.log(e);
            }
        },

        // 刪除
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此請款單？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    url: 'ServiceOrder/DeletePayment',
                    method: 'DELETE',
                    data: { sno: this.$route.params.sno },
                });
                this.onClose();
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        // 自動填入請款資料（多數欄位以第一筆資料為準）
        fillPaymentFields(serviceFeeList, existsPaymentData = null) {
            // 確認有勞報單
            if (!serviceFeeList || serviceFeeList.length <= 0) return;

            // 無請款單資料（新的轉送）
            if (!existsPaymentData) {
                // 取得第一筆已選取的勞報單
                const firstData = serviceFeeList[0];
                if (firstData) {
                    // 使用第一筆勞報單資料帶入的欄位
                    this.form.serviceType = firstData.incomeType; // 所得類別
                    this.form.serviceSubType = firstData.serviceType; // 業務類別
                    this.form.otherServiceType = firstData.otherServiceType; // 其他業務類別敘述
                    this.form.oS_MEM = this.combineField(serviceFeeList, 'description', '\n\n'); // 工作內容
                    this.form.poo = firstData.projectPoo; // 專案編號
                    this.form.cny = firstData.cny; // 幣別
                    this.form.useR_PAY_WAY = this.serviceFeePayWayToPaymentPayWay(firstData.plannedPayWay); // 預計付款方式
                    this.form.paY_CNYRAT = firstData.cnyRat; // 約定匯率!!!
                    this.form.nam = this.combineField(serviceFeeList, 'nam', '、'); // 摘要
                    this.form.dat = firstData.plannedPayDat; // 請款單日期 = 預計付款日
                    this.form.pdat = firstData.plannedPayDat; // 預計付款日
                    this.form.abd = firstData.abd; // 委外勞務國籍
                    this.form.accountType = firstData.accountType; // 收款帳戶類型(本國/外國)
                    this.form.abroadBankName = firstData.abroadBankName; // 外國銀行名稱
                    this.form.swiftCode = firstData.swiftCode; // Swiftcode
                    this.form.vdR_SNO = firstData.personalOutsourcingSno; // 委外勞務SNO
                    this.form.vdR_BNK_TPC = firstData.bnkNam; // 收款戶名
                    this.form.vdR_BNK_ACC = firstData.bnkAcc; // 收款帳號
                    this.form.vdR_BNK_BOO = firstData.bnkBoo; // 收款銀行代號
                    this.form.vdR_BNK_DOO = firstData.bnkDoo; // 收款分行代號
                    this.form.vdR_BNK_NOTE = firstData.bnkNote; // 收款帳戶備註
                    this.form.vdR_NAM = firstData.payee; // 付款對象名稱 = 領款人名
                    this.form.vdR_TEL = firstData.phone; // 電話
                    this.form.vdR_EML = firstData.email; // E-mail

                    this.payeeNam = firstData.payee; // 委外勞務姓名 = 領款人
                    this.isProjectOnly = !!firstData.projectPoo; // 是否限定專案請款

                    if (!this.isFullAuditFlow) this.form.clearanceAccno = firstData.projectPoo ? '2121' : '2131'; // 沖帳科目，專案請款使用2121，其他請款使用2131

                    // 是否投保職業工會
                    this.hasUnionInsurance = false;
                    if (firstData.hasUnionInsurance) {
                        const endOfDay = moment().endOf('day');
                        this.hasUnionInsurance = moment(firstData.unionInsuranceExpireDate).isAfter(endOfDay);
                    }

                    // 簡易流程欄位
                    if (!this.isFullAuditFlow) {
                        this.form.paY_WAY = this.serviceFeePayWayToPaymentPayWay(firstData.plannedPayWay); // 實際付款方式
                        this.form.paY_DAT = firstData.plannedPayDat; // 實際付款日
                    }

                    // 有專案
                    if (firstData.projectSno) {
                        this.form.typ = 2; // 請款類型設為「專案請款」
                        this.selectedProject = {
                            poo: firstData.projectPoo,
                            nam: firstData.projectNam,
                        };
                    }
                }
                // 使用全部勞報單加總的欄位
                this.form.amt = _.sumBy(this.selectedServiceFeeList, 'amt');

                // 依此單總數自動計算代扣（有可能和原本勞報單單獨稅額加總不同，用戶須自己注意）
                this.updateAutoTaxAndGen2();

                // 重新計算實付金額
                this.updateRealPayAmt();
            }
            // 已有請款單資料（退件編輯）
            if (existsPaymentData) {
                // 使用原請款單資料帶入的欄位
                this.form = existsPaymentData;
                this.form.typ = existsPaymentData.typ;

                this.payeeNam = this.form.vdR_NAM; // 委外勞務姓名 = 領款人
                this.isProjectOnly = this.form.typ === 2; // 是否限定專案請款

                // 有專案
                if (this.form.poo) {
                    this.selectedProject = {
                        poo: this.form.poo,
                        nam: this.form.projectName,
                    };
                }

                // 重新計算實付金額 & 代扣金額
                this.updateAutoTaxAndGen2();
                this.updateRealPayAmt();
            }
        },

        // 彙整勞報單勞務內容至請款單工作內容（用換行符號分隔）
        combineField(serviceFeeList, field, seperater) {
            const fieldValueList = _.map(serviceFeeList, field);

            // 刪除空白的元素
            _.remove(fieldValueList, (n) => !n);

            return fieldValueList.join(seperater);
        },

        // 自動計算勞務稅金額
        updateTaxAmtByRatio() {
            // 未開啟自動稅率，依使用者輸入 % 計算
            const taxRatio = this.taxRatio / 100;
            this.form.taX_AMT = Math.floor(this.form.amt * this.form.paY_CNYRAT * taxRatio);
            this.taxAmtInOriginCny = Math.round((this.form.taX_AMT / this.form.paY_CNYRAT) * 100) / 100;
        },

        // 自動計算二代健保金額
        updateGen2AmtByRatio() {
            // 未開啟自動稅率，依使用者輸入 % 計算
            const gen2Ratio = this.gen2Ratio / 100;
            this.form.geN2_AMT = Math.round(this.form.amt * this.form.paY_CNYRAT * gen2Ratio);
            this.gen2AmtInOriginCny = Math.round((this.form.geN2_AMT / this.form.paY_CNYRAT) * 100) / 100;
        },

        // 選取經常性支出專案
        async onOftenProjectChange(sno) {
            // 取得經常性支出專案 sno
            const oftenProject = this.oftenProjectList.find((p) => p.sno === sno);

            if (oftenProject) {
                // 取得經常性支出資料
                const resp = await this.$api({
                    url: `PaymentManagenmentPage/GetOftenOptionDetail?SNO=${oftenProject.sno}`,
                    method: 'GET',
                });

                this.selectedOftenProjectDetail = resp.data.detail;
                // 摘要預設同經常性名稱
                this.form.nam = oftenProject.iteM_NAM;
                // 清空已開請款單列表
                this.projectPayouts = [];
                // 設定幣別
                this.form.cny = 'TWD';
            } else {
                this.$message({
                    showClose: true,
                    message: '無法取得專案資料。',
                    type: 'error',
                });
            }
        },

        // 加選勞報單
        addSelectedServiceFee(item) {
            // 確認存在＆不重複
            if (!item) return;
            if (this.selectedServiceFeeList.find((s) => s.sno === item.sno)) {
                console.log('勞報單重複', item);
                return;
            }

            // 加入
            this.selectedServiceFeeList.push(item);
            this.fillPaymentFields(this.selectedServiceFeeList, null); // 重新計算、帶入欄位資訊
        },

        // 移除勞報單
        removeSelectedServiceFeeBySno(sno) {
            this.selectedServiceFeeList = _.remove(this.selectedServiceFeeList, (n) => n.sno !== sno);
            this.fillPaymentFields(this.selectedServiceFeeList, null); // 重新計算、帶入欄位資訊
        },
        onChangeAttachment(val, fieldName) {
            this.form[fieldName] = val.filE_ATT;
        },
        onCnyRatChange() {
            this.onChangeAmt();
        },

        onBnkChange() {
            this.form.accountType = this.selectedBnk.accountType;
            this.form.vdR_BNK_BOO = this.selectedBnk.bnK_BOO;
            this.form.vdR_BNK_DOO = this.selectedBnk.bnK_DOO;
            this.form.abroadBankName = this.selectedBnk.abroadBankName;
            this.form.swiftCode = this.selectedBnk.swiftCode;
            this.form.vdR_BNK_TPC = this.selectedBnk.bnK_TPC;
            this.form.vdR_BNK_ACC = this.selectedBnk.bnK_ACC;
        },
        onAddServiceFeeStatement() {
            this.selectDialog.visible = true;
            this.selectDialog.payeeName = this.payeeNam;
        },
        onClose() {
            if (this.$route.query.from === 'payment') this.$router.push({ name: 'payment' });
            else this.$router.push({ name: 'service-fee-statement' });
        },
        onTaxCountMethodChange() {
            this.updateAutoTaxAndGen2();
            this.updateRealPayAmt();
        },
        async onSubmit() {
            try {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        // 檢查是否為審核流程空缺
                        await this.validateAuditFlow();

                        // 檢查請款單年份
                        await this.validateYearDiff();

                        // 檢查代扣所得稅日期不早於付款日期
                        if (this.isTaxNeeded && !this.isFullAuditFlow) {
                            if (this.isTaxPayDateInvalid || this.isGen2PayDateInvalid) {
                                this.$message({
                                    showClose: true,
                                    message: '代扣所得稅、代扣二代健保繳款日應於實際付款日之後',
                                    type: 'error',
                                });
                                return;
                            }
                        }

                        // 檢查單據與金額
                        await this.validateFileAmt();

                        if (!this.isFullAuditFlow) {
                            // 簡易流程，連動欄位
                            // 預計付款日期 = 付款日期
                            this.form.pdat = this.form.paY_DAT;
                        }

                        // 送出請款資料
                        this.submitPayment();
                    } else {
                        // 表單驗證未過
                        this.$message.warning({
                            showClose: true,
                            message: '請填寫必填欄位',
                            type: 'warning',
                        });
                        this.scrollViewToError();
                    }
                });
            } catch (e) {
                console.log(e);
                if (e.message === 'invaild-audit-flow') {
                    await this.$alert('沒有對應的審核流程，請確認付款金額與審核流程預覽。');
                    const isError = document.getElementById('no-flow-error');
                    isError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }
        },

        // 送出前的資料修正
        normalizeDataBeforeSubmit() {
            // 委外廠商為外國時，境外身份預設為 2:民間
            if (this.form.abD_TYP === null) this.form.abD_TYP = 2;

            // 台幣請款，匯率為 1
            if (this.form.cny === 'TWD') {
                this.form.paY_CNYRAT = 1;
            }

            // 外幣請款，勞務稅 & 二代健保改用原幣別金額
            if (this.form.cny !== 'TWD') {
                this.form.taX_AMT = this.taxAmtInOriginCny;
                this.form.geN2_AMT = this.gen2AmtInOriginCny;
            }

            // 勞務稅、二代健保有金額 CHK = true
            this.form.taX_CHK = !!this.form.taX_AMT;
            this.form.geN2_CHK = !!this.form.geN2_AMT;

            // 簡易流程，連動欄位
            if (!this.isFullAuditFlow) {
                // 實際付款方式 = 付款方式
                this.form.paY_WAY = this.form.useR_PAY_WAY;

                // 付款方式為現金時，清除付款銀行
                if (this.form.paY_WAY === 1) this.form.paY_BNK_SNO = null;

                // 預計付款日期 = 付款日期
                this.form.pdat = this.form.paY_DAT;

                // 代扣-付款銀行、付款方式
                this.form.taX_BNK_SNO = this.form.taX_BNK_SNO === -1 ? -1 : this.form.taX_BNK_SNO;
                this.form.taX_PAY_WAY = this.form.taX_BNK_SNO === -1 ? 1 : 2;
                this.form.geN2_BNK_SNO = this.form.geN2_BNK_SNO === -1 ? -1 : this.form.geN2_BNK_SNO;
                this.form.geN2_PAY_WAY = this.form.geN2_BNK_SNO === -1 ? 1 : 2;
            }
            // 自訂流程
            if (this.isFullAuditFlow) {
                // 確認清除非自訂流程填寫欄位
                this.form.paY_WAY = null; // 實際付款方式
                this.form.paY_DAT = null; // 實際付款日
                this.form.iteM_SNO = null; // 支出項目
                this.form.accno = null; // 會計科目
                this.form.taX_BNK_SNO = null; // 代扣所得稅-付款銀行
                this.form.taX_PAY_DAT = null; // 代扣所得稅-付款日期
                this.form.taX_PAY_WAY = null; // 代扣所得稅-付款方式
                this.form.geN2_BNK_SNO = null; // 代扣二代健保-付款銀行
                this.form.geN2_PAY_DAT = null; // 代扣二代健保-付款日期
                this.form.geN2_PAY_WAY = null; // 代扣二代健保-付款方式
            }
        },

        // 送出請款
        async submitPayment() {
            this.normalizeDataBeforeSubmit(); // 資料修正
            console.log('upsert payment', this.form);

            try {
                this.isSubmitting = true;

                const resp = await this.$api({
                    url: 'ServiceOrder/TransferIntoPayment',
                    method: 'POST',
                    data: {
                        ...this.form,
                        taX_BNK_SNO: this.form.taX_BNK_SNO === -1 ? null : this.form.taX_BNK_SNO,
                        geN2_BNK_SNO: this.form.geN2_BNK_SNO === -1 ? null : this.form.geN2_BNK_SNO,
                        taX_PAY_WAY: this.form.taX_BNK_SNO === -1 ? 1 : 2,
                        geN2_PAY_WAY: this.form.geN2_BNK_SNO === -1 ? 1 : 2,
                        ServiceFeeStatementSnos: _.map(this.selectedServiceFeeList, 'sno'),
                    },
                });
                // 檢查是否需要列印請款單
                const isShowPrintTip = await this.checkIsShowPrintTip(resp.data.sno);
                if (!isShowPrintTip) {
                    this.$router.push({ name: 'payment' });
                }
            } finally {
                this.isSubmitting = false;
            }
        },

        // 檢查是否需要列印請款單
        async checkIsShowPrintTip(sno) {
            if (this.companyInfo.isShowPrintTip) {
                try {
                    await this.$confirm('是否列印請款單', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                    });
                    this.$router.push({ name: 'payment-pdf', params: { sno } });
                    return true;
                } catch (e) {
                    console.log(e);
                    return false;
                }
            }
            return false;
        },
        // 檢查是否為審核流程空缺
        async validateAuditFlow() {
            if (!this.isFlowValidate) {
                throw new Error('invaild-audit-flow');
            }
        },
        // 檢查單據與金額
        async validateFileAmt() {
            // 總金額 和 單據金額不符 ( 非財務支出 )
            if (this.form.amt !== this.receiptAmtTotal && this.form.typ !== 6) {
                const FILES = _.chain(this.form.files)
                    .filter((o) => !o.delete)
                    .value();
                if (!FILES.length) {
                    return confirm.call(this, '請款單應有檢附單據，讓每筆帳都有憑有據。', '沒有檢附單據，確定要送出嗎？');
                }
                return confirm.call(this, '請款單的應付總額應要等於單據的總金額，才能讓每筆帳都乾淨正確。', '應付總額與單據總金額不符，確定要送出嗎？');
            }
            return true;
        },
        // 檢查請款單年份
        async validateYearDiff() {
            if (!this.isFullAuditFlow) {
                // 簡易流程，連動欄位
                // 預計付款日期 = 付款日期
                this.form.pdat = this.form.paY_DAT;
            }
            const datYear = new Date(this.form.dat).getFullYear();
            const pdatYear = new Date(this.form.pdat).getFullYear();

            if (datYear !== pdatYear) {
                return confirm.call(this, `請款單日期(${datYear}) 與付款日(${pdatYear}) 年份不同！確定要送出？`, '警告');
            }
            return true;
        },

        getCnyRat(cny) {
            const cnyOption = this.cnyOptions.find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        onTypChange() {
            if (!this.isFullAuditFlow) {
                if (this.form.typ === 2) this.form.clearanceAccno = '2121';
                else this.form.clearanceAccno = '2131';
            }

            // 特別費用
            if (this.form.typ === 3) {
                // 載入特別費用列表
                this.fetchSpecialProjectList();
            }
            // 經常性支出
            if (this.form.typ === 4) {
                // 載入經常性支出列表
                this.fetchOftenOptions();
                // 清除已選專案資料
                this.form.poo = null;
                this.form.projectSno = null;
            }
        },
        onVariableStateItemChange(val) {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.setSuggestAccountItems(val);
            });
        },

        onAhSuggestAccountingItemsSelectorLoaded() {
            this.isAhSuggestAccountingItemsSelectorShow = this.isPayed('G01') || this.$store.getters['account/isSAAdmin'];
        },

        onSelectDialogClose() {
            this.selectDialog.visible = false;
        },
        onSelectDialogSubmit(items) {
            console.log('items', items);
            this.selectDialog.visible = false;
            items.forEach((item) => {
                console.log('item', item);
                this.addSelectedServiceFee(item);
            });
        },

        // 自動滾動到有錯誤的欄位
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            }, 100);
        },

        // 所得類型
        getIncomeType(incomeType) {
            const FOUND = _.find(serviceTypeList, ['value', incomeType]);
            return FOUND?.type;
        },

        // 業別代號
        getServiceType(serviceType) {
            const FOUND = _.find([...serviceType9AList, ...serviceType9BList], ['key', serviceType]);
            return FOUND ? `${FOUND.key}：${FOUND.label}` : '';
        },
        onProjectChange() {},

        onChangeTaxRatio() {
            this.updateTaxAmtByRatio();
            this.updateRealPayAmt();
        },

        onChangeGen2Ratio() {
            this.updateGen2AmtByRatio();
            this.updateRealPayAmt();
        },

        onChangeTaxAmt() {
            this.taxAmtInOriginCny = this.form.taX_AMT / this.form.paY_CNYRAT;
            this.updateRealPayAmt();
        },

        onChangeGen2Amt() {
            this.gen2AmtInOriginCny = this.form.geN2_AMT / this.form.paY_CNYRAT;
            this.updateRealPayAmt();
        },

        onChangeEnableAutoTax() {
            if (this.isEnableAutoTax) {
                this.updateAutoTaxAndGen2();
            }
        },

        onChangeAmt() {
            // 有開啟自動稅率計算
            if (this.isEnableAutoTax) {
                this.updateAutoTaxAndGen2();
            }
            // 未開啟自動稅率計算，依使用者輸入%計算金額
            if (!this.isEnableAutoTax) {
                this.updateTaxAmtByRatio();
                this.updateGen2AmtByRatio();
            }
            this.updateRealPayAmt();
        },

        // 更新實付金額
        updateRealPayAmt() {
            // 更新實付金額（約當台幣）
            this.realPayAmtTwd = Math.round(this.form.amt * this.form.paY_CNYRAT) - this.form.taX_AMT - this.form.geN2_AMT;

            // 更新實付金額（原幣別）到小數點第二位
            this.realPayAmtInOriginCny = (Math.round(this.form.amt * this.form.paY_CNYRAT) - this.form.taX_AMT - this.form.geN2_AMT) / this.form.paY_CNYRAT;
            this.realPayAmtInOriginCny = Math.round(this.realPayAmtInOriginCny * 100) / 100;
        },

        // 開啟自動計算稅率時，自動取得稅率＆稅金
        updateAutoTaxAndGen2() {
            const amt = this.form.amt * this.form.paY_CNYRAT; // 支付金額（台幣）
            const incomeType = this.form.serviceType; // 所得類別
            const isResident = this.form.abd !== 2; // 國籍 0:本國 & 1:外國(滿183天) = 居住者;  2:外國(未滿183天) = 非居住者

            if (this.taxCountMethod === 'sum') {
                this.form.taX_AMT = _.sumBy(this.selectedServiceFeeList, 'taxAmt');
                this.taxAmtInOriginCny = this.form.taX_AMT / this.form.paY_CNYRAT;
                this.form.taX_CHK = this.form.taX_AMT > 0;
                this.taxRatio = this.selectedServiceFeeList[0].taxRatio;

                this.form.geN2_AMT = _.sumBy(this.selectedServiceFeeList, 'gen2Amt');
                this.gen2AmtInOriginCny = this.form.geN2_AMT / this.form.paY_CNYRAT;
                this.form.geN2_CHK = this.form.geN2_AMT.amt > 0;
                this.gen2Ratio = this.selectedServiceFeeList[0].gen2Ratio;
                return;
            }

            // 勞務稅
            const taxInfo = getTaxAmtInfo(incomeType, amt, isResident);
            this.taxRatio = taxInfo.ratio;
            this.form.taX_CHK = taxInfo.amt > 0;
            this.form.taX_AMT = taxInfo.amt;
            this.taxAmtInOriginCny = this.form.taX_AMT / this.form.paY_CNYRAT;

            // 二代健保
            const gen2Info = getGen2AmtInfo(incomeType, amt, this.hasUnionInsurance);
            this.gen2Ratio = gen2Info.ratio;
            this.form.geN2_CHK = gen2Info.amt > 0;
            this.form.geN2_AMT = gen2Info.amt;
            this.gen2AmtInOriginCny = this.form.geN2_AMT / this.form.paY_CNYRAT;
        },

        // 「勞報單付款方式代號」轉換為「請款單付款方式代號」
        serviceFeePayWayToPaymentPayWay(serviceFeePayWay) {
            // 勞報單：1 = 現金, 2 = 銀行轉帳
            // 請款單：1 = 現金, 2 = 銀行轉帳, 3 = 銀行提現
            if (serviceFeePayWay === 1) return 1; // 「現金」預設用「零用現金」
            if (serviceFeePayWay === 2) return 2;
            return 2;
        },
    },
};
</script>

<style lang="scss">
.service-fee-statement-transform-page {
    .ah-panel {
        margin-bottom: 40px;
    }

    .project-select {
        width: 100%;
    }

    .date-warning {
        font-size: 9pt;
        color: rgb(255, 119, 0);
        margin-left: 10px;
    }

    .form-section-title {
        font-size: 10pt;
        font-weight: bold;
        padding: 5px 0;
        margin: 0 15px 25px 15px;
        color: #555;
        border-bottom: 1px solid #555;
    }

    .transfer-graph {
        display: flex;
        max-width: 500px;
        margin: 0 auto;
        padding: 0 22px;
        color: #463cb2;
        font-weight: bold;
        font-size: 12pt;
        align-items: center;
        gap: 35px;

        > .from {
        }
        > .arrow {
            flex-grow: 1;
            .arrow-line {
                position: relative;
                width: 100%;
                height: 2px;
                background-color: #463cb2;

                &::after {
                    position: absolute;
                    top: -5px;
                    right: -3px;
                    content: "";
                    width: 0;
                    height: 0;
                    border-style: solid;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-left: 10px solid #463cb2;
                    border-right: 0;
                }
            }
        }
        > .to {
            display: flex;
            align-items: center;
        }

        .reject-label {
            font-size: 9pt;
            color: red;
            border: 1px solid red;
            padding: 0px 5px;
            border-radius: 5px;
            margin-left: 10px;
            height: 22px;
            line-height: 20px;
        }
    }
}
</style>
